import { create } from 'zustand';

interface IRejectedError {
	message?: string;
	name?: string;
}

export type TRejectedErrorsStoreState = {
	errorsQueue: IRejectedError[];
};

export type TRejectedErrorsStoreActions = {
	addToErrorsQueue: (error: IRejectedError) => void;
	removeFromQueue: (error: IRejectedError[]) => void;
};

export const useRejectedErrorsStore = create<TRejectedErrorsStoreState & TRejectedErrorsStoreActions>((set) => ({
	addToErrorsQueue: (error) => set((state) => ({ errorsQueue: [...state.errorsQueue, error] })),
	errorsQueue: [],
	removeFromQueue: (queue: IRejectedError[]) =>
		set((state) => ({ errorsQueue: state.errorsQueue.filter((error) => !queue.includes(error)) })),
}));
